import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';

import { SharedService } from 'src/app/services/shared.service';

@Injectable({
  providedIn: 'root'
})
export class ProfileGuard  {

  constructor(
    private _sharedService: SharedService,
    private _router: Router
  ) {
    
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if(this._sharedService.validSession()) {
      return true
    } else {
      this._router.navigate(['login'])
      console.log('No tiene sesion iniciada');
      return false
      
    }
  }


  
}
